import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { Label } from '../ui/label';
import { Input } from '../ui/input';
import { Button } from '../ui/button';

/**
 * Diálogo para añadir un nuevo lugar de trabajo cuando no existe en la lista.
 *
 * @param {boolean}  open
 * @param {function} onOpenChange
 * @param {{codigo:string, descripcion:string}} value
 * @param {function} onChange      (nextValue) => void
 * @param {function} onSave        () => void (handler de guardado en backend)
 * @param {boolean}  saving
 */
export function OtroLugarDialog({ open, onOpenChange, value, onChange, onSave, saving }) {
  const handleCancel = () => {
    onOpenChange(false);
    onChange({ codigo: '', descripcion: '' });
  };

  const disabled = saving || !value?.codigo?.trim?.() || !value?.descripcion?.trim?.();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent style={{ maxWidth: '500px' }}>
        <DialogHeader>
          <DialogTitle style={{ color: '#1a5c2e' }}>Añadir Nuevo Lugar de Trabajo</DialogTitle>
          <DialogDescription>
            Introduce el código del centro de coste y su descripción
          </DialogDescription>
        </DialogHeader>
        <div style={{ padding: '20px 0' }}>
          <div style={{ marginBottom: '16px' }}>
            <Label htmlFor="codigo">Código *</Label>
            <Input
              id="codigo"
              data-testid="otro-lugar-codigo-input"
              placeholder="Ej: 00000"
              value={value.codigo}
              onChange={(e) => onChange({ ...value, codigo: e.target.value })}
              disabled={saving}
            />
          </div>
          <div style={{ marginBottom: '20px' }}>
            <Label htmlFor="descripcion">Descripción *</Label>
            <Input
              id="descripcion"
              data-testid="otro-lugar-descripcion-input"
              placeholder="Ej: Limpieza Viaria y Reco Bcn"
              value={value.descripcion}
              onChange={(e) => onChange({ ...value, descripcion: e.target.value })}
              disabled={saving}
            />
          </div>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
            <Button
              type="button"
              variant="outline"
              data-testid="otro-lugar-cancel-button"
              onClick={handleCancel}
              disabled={saving}
            >
              Cancelar
            </Button>
            <Button
              type="button"
              data-testid="otro-lugar-save-button"
              onClick={onSave}
              disabled={disabled}
              style={{ background: '#2d8a4e', color: '#fff' }}
            >
              {saving ? 'Guardando...' : 'Guardar y Seleccionar'}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default OtroLugarDialog;
